/**
 * Canonical enums (docs/VOCABULARY.md). Prisma enums carry the same names and values; zod enums are derived here so
 * DTOs, state machines and the schema never drift. Append values only in VOCABULARY first.
 */
import { z } from 'zod';
export const LotteryMechanic = z.enum([
    'SCHEDULED_RAFFLE',
    'INSTANT_WIN',
    'SPIN_WHEEL',
    'SCRATCH_CARD',
    'NUMBER_PICK',
    'FIRST_N',
    'FREE_GIVEAWAY',
]);
export const LotteryStatus = z.enum([
    'DRAFT',
    'REVIEW',
    'APPROVED',
    'SCHEDULED',
    'LIVE',
    'PAUSED',
    'CLOSED',
    'DRAWN',
    'SETTLED',
    'CANCELLED',
]);
export const EntryMode = z.enum(['FREE', 'PAID']);
export const EntryStatus = z.enum([
    'PENDING',
    'ELIGIBLE',
    'SNAPSHOT_INCLUDED',
    'INELIGIBLE',
    'REFUNDED',
    'DISQUALIFIED',
]);
export const EntrySource = z.enum(['FREE', 'PAID', 'BONUS']);
export const PaymentStatus = z.enum([
    'INITIALIZED',
    'PENDING',
    'SUCCEEDED',
    'FAILED',
    'EXPIRED',
    'CANCELLED',
    'REFUNDED',
    'PARTIALLY_REFUNDED',
    'RECONCILIATION_EXCEPTION',
]);
export const DrawStatus = z.enum([
    'COMMITTED',
    'SNAPSHOT_LOCKED',
    'ALLOCATED',
    'PUBLISHED',
    'REVEALED',
    'VERIFIED',
    'FAILED',
    'CANCELLED',
]);
export const WinSource = z.enum(['DRAW', 'INSTANT', 'SAMPLING']);
export const WinStatus = z.enum([
    'WON',
    'CLAIM_OPENED',
    'CLAIM_SUBMITTED',
    'APPROVED',
    'FULFILLED',
    'EXPIRED',
    'FORFEITED',
    'REDRAWN',
]);
export const HoldStatus = z.enum(['ACTIVE', 'CONVERTED', 'EXPIRED', 'RELEASED']);
export const ClaimStatus = z.enum([
    'OPENED',
    'VARIANT_HELD',
    'SUBMITTED',
    'VERIFICATION_PENDING',
    'VERIFIED',
    'MORE_INFO',
    'REJECTED',
    'APPROVED',
    'IN_FULFILLMENT',
    'PAID',
    'DELIVERED',
    'EXPIRED',
    'FORFEITED',
    'REDRAWN',
]);
export const VerificationDecision = z.enum(['VERIFIED', 'REJECTED', 'MORE_INFO', 'PENDING']);
export const WinnerContactStatus = z.enum(['NOT_MESSAGED', 'BUTTON_TAPPED', 'MESSAGED', 'FOLLOWED_UP']);
export const FulfillmentStatus = z.enum(['NOT_READY', 'READY', 'IN_PROGRESS', 'EXCEPTION', 'COMPLETED']);
export const FulfillmentType = z.enum(['CASH', 'PHYSICAL', 'DIGITAL', 'IN_PERSON']);
export const PrizeTier = z.enum(['GRAND', 'MAJOR', 'MINOR', 'SPONSOR_SAMPLE']);
export const SponsorTier = z.enum(['TITLE', 'GOLD', 'SUPPORTING']);
export const SupportCaseStatus = z.enum([
    'OPEN',
    'ASSIGNED',
    'WAITING_PARTICIPANT',
    'WAITING_PLATFORM',
    'RESOLVED',
    'CLOSED',
]);
export const SocialPlatform = z.enum([
    'WHATSAPP',
    'INSTAGRAM',
    'FACEBOOK',
    'TIKTOK',
    'X',
    'TELEGRAM',
    'OTHER',
]);
export const EngagementTaskType = z.enum(['REFERRAL', 'SHARE', 'FOLLOW', 'LINK_CHANNEL', 'DAILY_STREAK']);
export const TaskCompletionStatus = z.enum(['PENDING', 'QUALIFIED', 'REJECTED']);
export const StaffRole = z.enum([
    'ORGANIZER_ADMIN',
    'LOTTERY_APPROVER',
    'DRAW_OPERATOR',
    'ENGAGEMENT_ADMIN',
    'CLAIMS_REVIEWER',
    'FINANCE',
    'SPONSOR_VIEWER',
    'PLATFORM_SUPER_ADMIN',
]);
export const SelectionMode = z.enum(['FIXED_PRODUCT', 'VALUE_CAP']);
export const EnergyLevel = z.enum(['FULL', 'CALM']);
export const CountingMode = z.enum(['QUALIFIED_ENTRY', 'UNIQUE_PARTICIPANT']);
export const LedgerAccount = z.enum([
    'PARTICIPANT_RECEIVABLE',
    'PROVIDER_CLEARING',
    'PROVIDER_FEES',
    'ENTRY_REVENUE',
    'REFUNDS',
    'CHARGEBACKS',
    'PRIZE_COST',
    'PAYOUTS_PAYABLE',
    'TAXES',
    'SETTLEMENT',
]);
export const AuditActorKind = z.enum(['STAFF', 'PARTICIPANT', 'SYSTEM', 'PROVIDER', 'SPONSOR']);
/** §19 event contract — outbox topics. */
export const DomainEventTopic = z.enum([
    'lottery_viewed',
    'rules_expanded',
    'entry_started',
    'entry_submitted',
    'payment_pending',
    'entry_confirmed',
    'task_completed',
    'reveal_presented',
    'reveal_skipped',
    'sponsor_sample_awarded',
    'claim_started',
    'variant_held',
    'claim_submitted',
    'verification_decided',
    'message_button_tapped',
    'winner_marked_messaged',
    'fulfillment_completed',
    'sponsor_impression',
    'support_escalated',
    'lottery_published',
    'lottery_closed',
    'draw_committed',
    'draw_published',
    'payment_succeeded',
    'payment_refunded',
    'hold_expired',
    'claim_expired',
    'payout_approved',
]);
export const DRAW_ALGORITHM = 'DLP1-HMAC-SHA256-FY';
//# sourceMappingURL=enums.js.map